<template>
    <div class="edit-wrapper text-left">
        <div v-for="fragment in fragments" :key="fragment.id" class="d-inline">
            <p class="d-inline">{{ fragment.fragmentTekst }}</p>
            <div v-if="fragment.variableToFill" class="d-inline mx-50">
                <select-variable
                    :exclude="['assignedAgent']"
                    :value="fragment.variableValue"
                    set-search-after-blur
                    @input="(value) => setVariable(fragment.variableId, value, fragment)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import useEngageForm from "@/views/modules/engage/useEngageForm";
import SelectVariable from "@/components/selectVariable.vue";

export default {
    components: {
        SelectVariable,
    },
    emits: ["templateFilled", "editFinished"],
    setup(props, { emit, root }) {
        const bvModal = root.$bvModal;
        const { currentStep, selectedEngageToEdit } = useEngageForm(bvModal);
        const fragmentTexts = currentStep.value.templateSkeleton.split(/__variableId:\d+__/);
        const fragments = fragmentTexts.map((fragmentTekst, index) => ({
            id: index,
            variableToFill: index !== fragmentTexts.length - 1,
            fragmentTekst,
            variableId: index,
            variableValue: currentStep.value.variables.get(index),
        }));

        onMounted(() => {
            emit(
                "templateFilled",
                fragments.every((fragment) => !fragment.variableValue?.match(/{{\d+}}/))
            );
        });

        const setVariable = (variable, value, fragment) => {
            fragment.variableValue = value;
            emit("editFinished", { variable, value });
        };

        return {
            fragments: ref(fragments),
            setVariable,
            currentStep,
        };
    },
};
</script>
